import lodash from 'lodash'
import types from '../mutation-types'

const keys = {
  CATEGORY_OPTIONS: 'categoryOptions',
}

const defaultState = {
  [keys.CATEGORY_OPTIONS]: [],
}

// getters
const getters = {
  [keys.CATEGORY_OPTIONS]: state => state[keys.CATEGORY_OPTIONS],
}

// actions
const actions = {
  async initCategoryOptions ({ state, commit, dispatch, rootGetters }) {
    dispatch(actions.resetCategoryOptions.name)
    const isTenant = rootGetters['user/isTenant']
    if (!isTenant) {
      await dispatch('ecircular/getCategories', undefined, { root: true })
      const results = rootGetters['ecircular/categories'].reduce((list, res) => {
        list.push({
          ...res,
          key: res.name,
          name: res.name,
          options: res.categories.map((cate) => ({
            ...cate,
            value: lodash.get(cate, 'value.categoryId') || cate.value,
          })),
        })
        return list
      }, [])
      commit(types.ALL_CATEGORIES, results)
    }
    return state[keys.CATEGORY_OPTIONS]
  },
  async appendCategoryOptions ({ state, commit }, data) {
    /**
     * @type {{ key: string, name: string, options: { name: string, value: string }[] }[]}
     */
    const categories = lodash.cloneDeep(state[keys.CATEGORY_OPTIONS])
    for (const d of data) {
      const group = categories.find((cate) => cate.key === d.key)
      if (!group) {
        categories.push(d)
        continue
      }
      for (const option of d.options) {
        const o = group.options.find((o) => o.value === option.value)
        if (o) continue
        group.options.push(option)
      }
    }
    commit(types.ALL_CATEGORIES, categories)
    return state[keys.CATEGORY_OPTIONS]
  },
  resetCategoryOptions ({ commit }) {
    commit(types.ALL_CATEGORIES, [])
  },
}

// mutations
const mutations = {
  [types.ALL_CATEGORIES] (state, data) {
    state[keys.CATEGORY_OPTIONS] = data
  },
  [types.RESET_STATE] (state) {
    state[keys.CATEGORY_OPTIONS] = []
  },
}

export default {
  namespaced: true,
  state: lodash.cloneDeep(defaultState),
  getters,
  actions,
  mutations,
}
